import _isString from 'lodash/isString';
import _contains from 'lodash/includes';
import _throttle from 'lodash/throttle';
import _debounce from 'lodash/debounce';
import stickybits from 'stickybits'

const defaults = {
  scrollRef : null,   //스크롤 엘리먼트 , 기본 윈도우
  edgeRef : null,
  stickerRef : null,
  position : 'TOP', // TOP , BOTTOM

  $topEdge : null,    // 둘중하나 필수
  $bottomEdge : null,

  replacerClass : 'sticker-replacer',
  activeClass : 'is-fixed',
  autoFixed : true

};

export class Sticky {
  constructor(element, binding, node) {
    this.element = element;
    this.node = node;
    this._defaults = defaults;
    this.options = Object.assign({}, this._defaults, binding.value);

    this.isTouchDevice = function () {
      return !!(typeof window !== 'undefined' && ('ontouchstart' in window || window.DocumentTouch && typeof document !== 'undefined' && document instanceof window.DocumentTouch)) || !!(typeof navigator !== 'undefined' && (navigator.maxTouchPoints || navigator.msMaxTouchPoints));
    }();
    this.isSupportSticky = function () {
      var el = document.createElement('a'),
        mStyle = el.style;mStyle.cssText = "position:sticky;position:-webkit-sticky;position:-ms-sticky;";return mStyle.position.indexOf('sticky') !== -1;
    }();
    this.cssPrefix = '-' + (Array.prototype.slice
      .call(window.getComputedStyle(document.documentElement, ''))
      .join('')
      .match(/-(moz|webkit|ms)-/) || (styles.OLink === '' && ['', 'o'])
    )[1] + '-'

    this.buildCache( node.context );

    this.setStickyPosition(node);
    if(!this.isSupportSticky) stickybits(element.children[0])

  }

  destroy(){
    const parent = this.$sticky.parentNode;

    if(!this.isSupportSticky) {
      this.unbindEvents();
    }
    this.$sticky.classList.remove( this.options.activeClass );
    this.$sticky && this.$sticky.removeAttribute('style');

    while (this.$sticky.firstChild) parent.insertBefore(this.$sticky.firstChild, this.$sticky);
    parent && parent.removeChild(this.$sticky);
  }

  buildCache( context ){

    this.$scroller = context.$refs[this.options.scrollRef] || window;
    this.$wrapper = this.element;
    this.$sticky = context.$refs[this.options.stickerRef];
    this.$edge = context.$parent.$refs[this.options.edgeRef];
    this.$parentStick = context.$refs[this.options.parentStickyRef];

    let _sticky = this.$sticky;
    let _parent = this.$parentStick;
    this.$sticky = Array.isArray(_sticky)?_sticky[0]:_sticky;
    this.$parentStick = Array.isArray(_parent)?_parent[0]:_parent;

    this.position = _isString(this.options.position) ? this.options.position.toUpperCase() : 'TOP';
    this.scrollY = 0;

    if(!this.isSupportSticky) {
      this.setReplacer();
    }
  }

  setReplacer(){

    if( !_contains(this.$sticky.parentElement.classList, this.options.replacerClass) ){

      this.$replacer = document.createElement('div');
      this.$replacer.classList.add(this.options.replacerClass);
      this.$sticky.parentElement.insertBefore(this.$replacer, this.$sticky);
      this.$replacer.appendChild(this.$sticky);
    }
  }

  resizer(){

    this.$sticky.classList.remove( this.options.activeClass );
    this.$sticky && this.$sticky.removeAttribute('style');
    this.$replacer && this.$replacer.removeAttribute('style');
    this.scroller();
  }

  scroller(){

    const newScrollY = this.$scroller.scrollTop;
    const direction = ((self) => {
      if( self.scrollY < newScrollY ){
        return 'DOWN';
      } else if( self.scrollY > newScrollY ){
        return 'UP';
      } else {
        return 'DOWN';
      }
    })(this);

    this.scrollY = newScrollY;
    this.wrapOffset = this.getBoundingClientRect( this.$wrapper );
    this.stickyOffset = this.getBoundingClientRect( this.$sticky );

    if( this.position === 'TOP' ){
      this._attachToHeadByScroll( direction );
      return;
    }
    if( this.position === 'BOTTOM' ){
      this._attachToFootByScroll( direction );
      return;
    }
  }

  _detachSticky(){

    this.$sticky.classList.remove( this.options.activeClass );
    this.$sticky && this.$sticky.removeAttribute('style');
    this.$replacer && this.$replacer.removeAttribute('style');

  }

  _setStylesOnElement( element, styles ){
    return element && Object.assign( element.style, styles)
  }

  _attachToHeadByScroll( direction ) {

    const headEdgeBottom = this.$edge?this.$parentStick?this.getBoundingClientRect(this.$parentStick).bottom:this.getBoundingClientRect( this.$edge ).bottom:0;
    let stickyTop = headEdgeBottom;

    if( this.wrapOffset.top <= headEdgeBottom ){
      if( direction === 'DOWN' ){
        if( this.stickyOffset.bottom >= this.wrapOffset.bottom ){
          stickyTop = this.wrapOffset.bottom - this.stickyOffset.height;
        }
      } else if( direction === 'UP' ){
        stickyTop = this.wrapOffset.bottom - this.stickyOffset.height;
        stickyTop = Math.min(stickyTop, headEdgeBottom);
      }

      this._setStylesOnElement( this.$replacer, {
        position : 'relative',
        zIndex : this.$parentStick?10:11,
        width : this.stickyOffset.width +'px',
        height : this.stickyOffset.height +'px'
      });

      if( this.options.autoFixed ){

        this._setStylesOnElement( this.$sticky, {
          position : 'fixed',
          width : this.wrapOffset.width +'px',
          top : stickyTop +'px',
          left : this.stickyOffset.left +'px'
        });

      } else {
        this.$sticky.classList.add( this.options.activeClass );
      }

    } else {
      this._detachSticky();
    }

  }

  _attachToFootByScroll( direction ) {

    const screenHeight = document.documentElement.clientHeight	|| window.innerHeight;
    let stickyBottom = 0;

    if( this.wrapOffset.bottom > screenHeight){
      if( direction === 'DOWN' ){
        if( screenHeight > this.wrapOffset.top ){
          stickyBottom = (this.stickyOffset.height*-1) + (screenHeight - this.wrapOffset.top);
          stickyBottom = stickyBottom > 0 ? 0 : stickyBottom;
        } else {
          this._detachSticky();
          return;
        }
      } else if( direction === 'UP' ){
        if( screenHeight - this.wrapOffset.top < this.stickyOffset.height ){
          stickyBottom = (this.stickyOffset.height*-1) + (screenHeight - this.wrapOffset.top);
        }
        if( stickyBottom < this.stickyOffset.height*-1 ){
          this._detachSticky();
          return;
        }
      }

      this._setStylesOnElement( this.$replacer, {
        position : 'relative',
        zIndex : 10,
        width : this.stickyOffset.width +'px',
        height : this.stickyOffset.height +'px'
      });

      if( this.options.autoFixed ){

        this._setStylesOnElement( this.$sticky, {
          position : 'fixed',
          width : this.wrapOffset.width +'px',
          bottom : stickyBottom +'px',
          left : this.stickyOffset.left +'px'
        });

      } else {
        this.$sticky.classList.add( this.options.activeClass );
      }
    } else {
      this._detachSticky();
    }
  }

  getBoundingClientRect( obj ){
    var rect = obj.getBoundingClientRect();
    if (typeof rect.width === 'undefined') {
      return {
        top: rect.top,
        bottom: rect.bottom,
        left: rect.left,
        right: rect.right,
        width: rect.right - rect.left,
        height: rect.bottom - rect.top
      };
    }
    return rect;
  }

  setStickyPosition (node){
    const wrapOffset = this.getBoundingClientRect( this.$wrapper )
    const headEdgeBottom = this.$edge?this.getBoundingClientRect( this.$edge ).bottom:0;
    this.$wrapper.style.position = 'relative';
    this.$wrapper.style.overflow = 'visible';
    this.$sticky.style.position = 'sticky';
    this.$sticky.style.position = this.cssPrefix + 'sticky';
    const topPosition = this.$parentStick ? this.getBoundingClientRect(this.$parentStick).height+'px' : 0;
    this.$sticky.style.top = this.isSupportSticky ? topPosition : 0;

    node.context.$watch('$store.state.headerHeight', (h) => {
      this.$sticky.style.top = (parseInt(topPosition)+h) + 'px';
    }, {deep: true})

  }

  bindEvents (){

    this.throttle = _throttle(() => {
      this.scroller()
    }, 16);

    this.debounce = _debounce(() => {
      this.resizer()
    }, 100);

    this.$scroller.addEventListener('scroll', this.throttle);
    this.$scroller.addEventListener('resize', this.debounce);
  }

  unbindEvents (){

    this.$scroller.removeEventListener('scroll', this.throttle);
    this.$scroller.removeEventListener('resize', this.debounce);

  }

}

export default {
  inserted: function(el, binding, node) {
    if (!process.browser) return;
    node.sticky = new Sticky(el, binding, node)
  },
  unbind (el, binding, node) {
    if(node.sticky) {
      node.sticky.destroy();
      node.sticky = null;
    }
  }
}
